import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const SwitchClassName = `${CLASS_NAME_PREFIX}-switch`;
export const SwitchCheckedClassName = `checked`;
export const SwitchClassNameLabel = `${SwitchClassName}__label`;
